import { useMemo } from "react";
import { selectSpeakers, useHMSStore } from "@100mslive/react-sdk";
import type { Peer } from "@circle-react/types/Live/Peer";
import { usePaginatedSortedPeers } from "../usePaginatedSortedPeers";
import { useHMSPeersList } from "./useHMSPeersList";

const DEFAULT_PAGE_SIZE = 8;

interface UseHMSSpeakerRotationOptions {
  pageSize?: number;
}

export const useHMSSpeakerRotation = (
  peers: Peer[],
  { pageSize = DEFAULT_PAGE_SIZE }: UseHMSSpeakerRotationOptions = {},
) => {
  const { peersWithHandRaised } = useHMSPeersList();
  const speakersObj = useHMSStore(selectSpeakers);
  const speakingIds = useMemo(
    () => Object.values(speakersObj).map(({ peerID }) => peerID),
    [speakersObj],
  );
  const handRaisedIds = useMemo(
    () => peersWithHandRaised.map(({ id }) => id),
    [peersWithHandRaised],
  );
  const orderedPeers = usePaginatedSortedPeers({
    peers,
    speakingIds,
    handRaisedIds,
    pageSize,
  });

  return {
    orderedPeers,
  };
};
